import React, { memo, ReactNode, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { SearchWithin } from './SearchWithin';
import { atom, useAtom } from 'jotai';

interface SearchFiltersState {
  open: boolean;
}

export const searchHeaderAtom = atom<SearchFiltersState>({ open: false });

export interface SearchFiltersProps {
  children: ReactNode;
  className?: string;
  queryVariables?: string[];
}

export const SearchFilters = memo(
  ({ children, queryVariables, className }: SearchFiltersProps) => {
    const [searchHeader, setSearchHeader] = useAtom(searchHeaderAtom);
    const [searchParams] = useSearchParams();

    useEffect(() => {
      const shouldOpen =
        queryVariables?.some(variable => searchParams.has(variable)) ?? false;
      setSearchHeader({ open: shouldOpen });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <StyledSearchFilters
        className={'search-filters ' + className}
        open={searchHeader.open}
      >
        <StyledSearchBar>
          <StyledFiltersContainer>{children}</StyledFiltersContainer>
        </StyledSearchBar>
      </StyledSearchFilters>
    );
  },
);
SearchFilters.displayName = 'TypedSearchFilters';

const StyledSearchBar = styled.section`
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
`;

export const StyledSearchWithin = styled.section`
  flex: 1;
`;

const StyledFiltersContainer = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

interface StyledSearchFiltersProps {
  open: boolean;
}

const StyledSearchFilters = styled.section<StyledSearchFiltersProps>`
  display: ${props => (props.open ? 'block' : 'none')};
`;
